export const linkColor = "#2BB24A";
export const linkColorForgot = "#1378C3";
export const whiteColor = "#fff";
export const blackColor = "#000";
export const redBorderInputColor = "#C83532";
export const redBackgroundColor = "#FBEFEF";
export const greyColor = "#979797";
export const greyColorBox = "#CECECE";
export const blueBorderBottomColor = "#4B38ED";
export const greenBold = "#2BB24A";
export const descriptionColor = "#rgba(0, 0, 0, 0.6)";
export const blockColor = "#F9F9F9";
export const dividerColor = blockColor;
export const greyColorText = "#3C3C3C";

export const subTitleColorRed = "#B50300";
export const subTitleColorBlue = "#0B446F";
export const subTitleColorYellow = "#E9C314";
export const subTitleColorGreen = "green";

export const blockColorRed = "#FFD3D3";
export const blockColorBlue = "#CEE2F4";
export const blockColorYellow = "#fdf2c6";
export const blockColorGreen = "#9bed99";
export const editProfileColor = "#21699F";
export const removeAccountColor = "#B50300";
export const companySloganColor = "#666666";
export const greyDisabledButtonColor = "rgba(0, 0, 0, 0.32)";
